import React from 'react';

const LockedScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        {/* Lock icon */}
        <div className="w-16 h-16 mx-auto mb-6 rounded-full border border-dark-500 flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <h1 className="font-display text-2xl font-semibold text-white mb-3">
          Private Link Required
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-8">
          This page requires a unique invite link. If you've partnered with SiteStackCo, check your email for your personalized onboarding link.
        </p>
        <div className="border border-dark-600 rounded-lg p-4 text-left">
          <p className="text-xs text-gray-600 mb-1">Questions? Reach us at</p>
          <a
            href="mailto:Create@SiteStackCo.com"
            className="text-sm text-lime-400 hover:underline font-medium"
          >
            Create@SiteStackCo.com
          </a>
        </div>
        <p className="text-xs text-dark-500 mt-8 font-display italic">SiteStackCo</p>
      </div>
    </div>
  );
};

export default LockedScreen;
